import React from "react";
import AllSummary from "./AllSummary";
import ItemWisePaymentList from "./ItemWisePaymentList";

const CollectionBox = ({
  title,
  tableTitle,
  tableHeader,
  tableUrl,
  summaryTitle,
  summaryUrl,
  exportDate,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 mt-12 lg:grid-cols-12 lg:gap-20">
        <div className="col-span-1 order-3 lg:col-span-9 lg:order-2">
          <ItemWisePaymentList
            title={tableTitle}
            tableHeader={tableHeader}
            url={tableUrl}
            exportDate={exportDate}
          />
        </div>

        <div className="col-span-1 order-2 lg:col-span-3 lg:order-3">
          <AllSummary title={summaryTitle} url={summaryUrl} />
        </div>
      </div>
    </>
  );
};

export default CollectionBox;
